import { getPlanningEntityIdentifiersFromEvent } from 'components/mrp/components/Calendar/components/CalendarAppointment/CalenderAppointment.utils';
import { PasteEventProps } from './utils.types';
import { getFormData } from './getFormData';
import { DialogType } from 'components/shared/DialogProvider/DialogProvider.enums';

export const pasteEvent = ({
  sourceEvent,
  calendars,
  isCut,
  calendarId,
  date,
  setIsProcessing,
  setFetchEntities,
  openDialog
}: PasteEventProps) => {
  setIsProcessing(true);

  const entitiesToReplace = calendars[sourceEvent.calendarId].sources.map(
    ({ planningEntityIdentifier }) => planningEntityIdentifier
  );

  // Entities currently part of the event
  const sourceEntities = getPlanningEntityIdentifiersFromEvent(
    sourceEvent.planningEvent
  );

  // Entities being added to the event as part of the paste action
  const targetEntities = calendars[calendarId].sources.map(
    ({ planningEntityIdentifier }) => planningEntityIdentifier
  );

  setFetchEntities([...targetEntities, ...sourceEntities]);

  const formData = getFormData({
    baseEvent: sourceEvent.planningEvent,
    isCut,
    newStart: date,
    sourceEntities,
    targetEntities,
    entitiesToReplace
  });
  formData.isCopyPasteAction = !isCut;

  openDialog?.(
    'smart-action-dialog-interactionhandler',
    DialogType.SMART_ACTION_DIALOG,
    {
      actionType: !formData.id ? 'create' : 'update',
      appointmentExceptions: formData?.appointmentExceptions,
      payload: formData,
      pasteType: isCut ? 'cut' : 'copy'
    }
  );
};
